import { useState, useEffect } from 'react'
import { bool, object, number, string, func, oneOfType, arrayOf } from 'prop-types'
import Div from '@ui/layout/Div'
import Icon from '@ui/elements/Icon'
import { get } from '@util/xhrAPI'
import Alert from '@ui/elements/Alert'
import Buttons from '@ui/elements/Buttons'

const SelectType = ({
  name,
  onChange = () => { },
  value,
  canCreate,
  creationModalCaller,
  icon,
  fetchUrl,
  error,
  cssClass = 'is-fullWidth',
  withIcon = false,
  options = [],
  label = '',
  help = '',
  disabled = false,
  isRequired = false,
  isLinked = false
}) => {
  const selectObject = {
    loaded: options.length > 0,
    options
  }
  const [selectState, setSelectState] = useState(selectObject)

  /**
   * Fetch data from server
   */
  const getData = async () => {
    if ((!selectState.loaded || isLinked) && fetchUrl) {
      await get(fetchUrl, response => {

        if (response.code === 200) {
          setSelectState({ ...selectState, ...{ options: response.data, loaded: true } })
        }
      })
    }
  }

  const makeChange = e => {
    if (!selectState.loaded) {
      getData()
    } else {
      onChange(e)
    }
  }

  useEffect(() => {
    getData()
  }, [fetchUrl])

  useEffect(() => {
    if ((!selectState.loaded && options.length) || (JSON.stringify(options) !== JSON.stringify(selectState.options) && !fetchUrl)) {
      setSelectState({ ...selectState, options, loaded: true })
    }
  }, [options])

  const renderOptions = selectState.options.map(option => {
    return (
      <option value={option.value} key={`${cssClass}-${option.value}`}>{option.label}</option>
    )
  })

  return (
    <>
      {!withIcon
        ? <Div cssClass={`field ${cssClass}`}>
          <Div cssClass='control'>
            {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
            <Div cssClass={`${canCreate ? 'can-create-field' : ''}`}>
              <Div cssClass='select'>
                <select onChange={makeChange} id={`input-${name}`} name={name} value={'object' === typeof value ? value.value : value} disabled={disabled}>
                  {selectState.loaded ? <option value=''></option> : ''}
                  {renderOptions}
                </select>
              </Div>
              {canCreate ? <Buttons buttons={{ icon: 'icon-add_circle', callback: creationModalCaller }} /> : <></>}
            </Div>
            {help && <p className='help'>{help}</p>}
            {error && <Alert cssClass='clear' type='is-danger' message={error} />}
          </Div>
        </Div >
        : <Div cssClass={`field ${cssClass}`}>
          <Div cssClass='control has-icons-left'>
            {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
            <Div cssClass='select'>
              <select onChange={onChange} id={`input-${name}`} name={name} value={typeof value === 'object' ? value.value : value} disabled={disabled}>
                {renderOptions}
              </select>
            </Div>
            <Icon icon={icon} spanClass='is-left' />
          </Div>
          {help && <p className='help'>{help}</p>}
          {error && <Alert cssClass='clear' type='is-danger' message={error} />}
        </Div>
      }
    </>
  )
}

SelectType.propTypes = {
  fetchUrl: string,
  name: string,
  onChange: func,
  cssClass: string,
  canCreate: bool,
  creationModalCaller: func,
  disabled: bool,
  withIcon: bool,
  icon: string,
  options: oneOfType([arrayOf(object), object]),
  help: string,
  label: string,
  value: oneOfType([string, object, number]),
  error: string,
  isRequired: bool,
  isLinked: bool
}

export default SelectType
